// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__HIorn","tabList":"tabs_tabList__DW-Tl","tabItem":"tabs_tabItem__N0kbT","active":"tabs_active__oYoUN","tabContent":"tabs_tabContent__sWUbD"};